/**
 * Sesotho: Dashboard
 *
 * What this file covers: The dashboard and its first-run setup checklist.
 *
 * Tone: Encouraging and brief. Tell the business what is happening and what to do next, in a few words.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const dashboard: Catalog = {
  'dashboard.welcome': 'Rea u amohela',
  'dashboard.title': 'Rea u amohela, {{name}}',
  'dashboard.title.anonymous': 'Rea u amohela hape',
  'dashboard.verifyBanner.title': 'Netefatsa imeile ea hau',
  'dashboard.verifyBanner.cta': 'Netefatsa hona joale →',
  'dashboard.metrics.unread': '{{count}} tse sa baloang',
  'dashboard.trend.percent': '{{value}}% ha e bapisoa le maobane',
  'dashboard.trend.points': '{{value}} lintlha ha li bapisoa le maobane',
  'dashboard.trend.flat': 'E tsitsitse',
  'dashboard.trend.flat.tooltip': 'Phetoho e nyenyane lihoreng tse 24 tse fetileng.',
  'dashboard.trend.tooltip': '{{current}} lihoreng tse 24 tse fetileng, ha li bapisoa le {{previous}} lihoreng tse 24 pele ho moo.',
  'dashboard.metrics.deliveryRate': 'Sekhahla sa ho fihla',
  'dashboard.metrics.deliveryHint': 'Ea melaetsa e rometsoeng lihoreng tse 24 tse fetileng',
  'dashboard.metrics.deliveryNone': 'Ha ho melaetsa e rometsoeng hajoale',
  'dashboard.viewMessages': 'Sheba melaetsa',
  'dashboard.recent.title': 'Lipuisano tsa morao tjena',
  'dashboard.recent.openInbox': 'Bula lebokoso le kenang →',
  'dashboard.recent.empty': 'Ha ho lipuisano hajoale.',
  'dashboard.recent.noMessages': 'Ha ho melaetsa',
  'dashboard.quickActions.title': 'Liketso tse potlakileng',
  'dashboard.quickActions.addContacts': 'Eketsa bao u ikopanyang le bona',
  'dashboard.quickActions.newTemplate': 'Template e ncha',
  'dashboard.quickActions.newBroadcast': 'Phatlalatso e ncha',
  'dashboard.quickActions.buildFlow': 'Haha phallo',
  'dashboard.quickActions.attachNumber': 'Hokela nomoro',
  'dashboard.quickActions.topUp': 'Tlatsa sepache',
  'setup.dismissed': 'Lenane la ho theha le patiloe. U ka le khutlisa ho Litlhophiso → Ponahalo.',
  'setup.progress.badge': '{{done}} ho tse {{total}} tse phethiloeng',
  'setup.step.done': 'E phethiloe',
  'setup.step.todo': 'Ha e e-so etsoe',
  'setup.restore': 'Bontsha lenane la ho theha',
  'setup.restore.hint': 'Khutlisa mehato ea pele ho dashboard.',
  'dashboard.sendBlock.title': 'Melaetsa ea hau ha e fihle',
  'dashboard.sendBlock.ACCOUNT_NOT_PAYABLE': 'WhatsApp e hana molaetsa o mong le o mong ho {{number}} ka lebaka la bothata ba tefo lehlakoreng la rona. Re a bo lokisa, mme ha ho hlokahale hore o etse letho ho Meta.',
  'dashboard.sendBlock.NUMBER_NOT_REGISTERED': '{{number}} ha e ngolisoa ho WhatsApp hore e romele, kahoo ha ho letho le rometsoeng ka eona le fihlang.',
  'dashboard.sendBlock.META_REFUSED': 'WhatsApp e hana molaetsa o mong le o mong ho {{number}}.',
  'dashboard.sendBlock.alsoOthers': 'Linomoro tse ling tse {{count}} le tsona li amehile.',
  'dashboard.sendBlock.notCharged': 'Ha u lefisoe bakeng sa molaetsa o sa fihlang.',
  'dashboard.sendBlock.action': 'Bula Linomoro'
};

export default dashboard;
